import { createMuiTheme } from '@material-ui/core/styles';

// https://github.com/mui/material-ui/issues/15914
// Material-UI doesn't work properly when there are multiple MuiThemeProviders as siblings but no shared parent.
// Resolving the below Jira ticket will eliminate the need to use a blank theme instead of a real theme,
//  since at that point it will be safe to do so.
// https://levelhome.atlassian.net/browse/MDU-263
export default createMuiTheme({});
